import { useContext, useEffect, useMemo, useState } from "react";
import "../../../assets/css/LgvPopup/LgvPopup.css";
import { AppContext } from "../../../Context/Context";
import useModalClose from "../../../hooks/useModalClose";
import { closeParticularMinimizedModal } from "../../../util/helper/helperFunctions";

import closeBtn from "../../../assets/icons/close.png";
import minimizeButton from "../../../assets/icons/minimize.png";
import followIcon from "../../../assets/icons/followIcon.png";
import followingIcon from "../../../assets/icons/followIconWhite.png";

import lgvGraphicsSensorsOpenFork from "../../../assets/images/lgvGraphicsSensorsOpenFork.svg";
import lgvGraphicsSensorsCloseFork from "../../../assets/images/lgvGraphicsSensorsCloseFork.svg";
import lgvGraphicsAlarmOpenFork from "../../../assets/images/openFork.svg";
import lgvGraphicsAlarmCloseFork from "../../../assets/images/closedFork.svg";
import lgvGoodLabelImage from "../../../assets/icons/lgvLabelTick.svg";
import lgvBadLabelImage from "../../../assets/icons/lgvLabelCross.svg";

import ToggleSwitch from "../../Reusables/ToggleSwitch/ToggleSwitch";
import LGVDataSection from "./LGVDataSection";
import OnboardPalletDataSection from "./OnboardPalletDataSection";
import RenderLgvGraphicModeMetaData from "./RenderLgvGraphicModeMetaData";
import NavQualityPopUp from "./NavQualityPopUp";
import { useDispatch, useSelector } from "react-redux";
import { setFollowingLgvList } from "../../../store/plantSlice";
import { MINIMIZE_COUNT } from "../../../util/helper/constants";
import useMinimizedModalFeature from "../../../hooks/useMinimizedModalFeature";

const sensorsAnnotationDetails = [
  {
    label: "Right Side PLS Sensor",
    key: "rightPLSDirty",
    className: "lgv-rspls-sensor"
  },
  {
    label: "Front PLS Sensor",
    key: "forwardPLSDirty",
    className: "lgv-fpls-sensor"
  },
  {
    label: "Left Side PLS Sensor",
    key: "leftPLSDirty",
    className: "lgv-lpls-sensor"
  },
  {
    label: "Right Vertical PLS Sensor",
    key: "verticalRightPLSDirty",
    className: "lgv-rvpls-sensor"
  },
  {
    label: "Left Vertical PLS Sensor",
    key: "verticalLeftPLSDirty",
    className: "lgv-lvpls-sensor"
  },
  {
    label: "Rear PLS Sensor",
    key: "backwardPLSDirty",
    className: "lgv-rpls-sensor"
  }
];

const alarmsAnnotationDetails = [
  {
    label: "Right Side PLS Alarm",
    className: "lgv-rspls-alarm"
  },
  {
    label: "Front PLS Alarm",
    className: "lgv-fpls-alarm"
  },
  {
    label: "Navigation Alarm",
    className: "lgv-nav-alarm"
  },
  {
    label: "Left Side PLS Alarm",
    className: "lgv-lpls-alarm"
  },
  {
    label: "Right Vertical PLS Alarm",
    className: "lgv-rvpls-alarm"
  },
  {
    label: "Left Vertical PLS Alarm",
    className: "lgv-lvpls-alarm"
  },
  {
    label: "LMS Sensor Alarm",
    className: "lgv-lms-alarm"
  },
  {
    label: "Rear PLS Alarm",
    className: "lgv-rpls-alarm"
  },
  { label: "Fork Alarm", className: "lgv-fork-alarm" }
];

const MODAL_ID = "lgv-wrapper-id";

const LgvPopup = ({ lgv: lgvData }) => {
  const {
    setIsMarkerPopupOpen,
    minimizedWebObjectsList,
    setMinimizedWebObjectsList,
    setAlertObject,
    setOpenedLgvVehichleNumber
  } = useContext(AppContext);

  const dispatch = useDispatch();
  const { data: vehicleDataFromSocket } = useSelector(
    (state) => state.plant.vehicleDataFromSocket
  );
  const followingLgvList = useSelector((state) => state.plant.followingLgvList);

  const { feature } = useMinimizedModalFeature();

  const [minimizeInitiated, setMinimizeInitiated] = useState(false);
  const [isLgvBeingFollowed, setIsLgvBeingFollowed] = useState(false);
  //LGV Graphic
  const [lgvGraphicImage, setLgvGraphicImage] = useState(
    lgvGraphicsAlarmOpenFork
  );
  const [selectedLgvGraphicMode, setSelectedLgvGraphicMode] = useState("alarm");

  useEffect(() => {
    if (followingLgvList[feature] && followingLgvList[feature].length !== 0) {
      let currentLgv = followingLgvList[feature].find(
        (currentLgv) => currentLgv.vehicleNumber === lgvData.vehicleNumber
      );
      if (currentLgv !== undefined) {
        setIsLgvBeingFollowed(true);
      }
    }
  }, [followingLgvList, feature]);

  useEffect(() => {
    setOpenedLgvVehichleNumber(lgvData.vehicleNumber);
    return () => {
      setOpenedLgvVehichleNumber(null);
    };
  }, [lgvData]);

  const closeModalHandler = () => {
    setIsMarkerPopupOpen(false);
    document.body.classList.remove("prevent-scroll");
  };

  const closeMinimizedLgvModal = () => {
    closeParticularMinimizedModal({
      list: minimizedWebObjectsList[feature].lgv,
      setMinimizedWebObjectsList,
      item: lgvData,
      type: "lgv",
      feature
    });
  };

  const minimizeModalHandler = () => {
    const currentLgvList = [...minimizedWebObjectsList[feature].lgv];

    const isLgvAlreadyMinimized = currentLgvList.some(
      (item) => item.vehicleNumber === lgvData.vehicleNumber
    );

    if (
      currentLgvList.length === MINIMIZE_COUNT.lgv &&
      !isLgvAlreadyMinimized
    ) {
      setAlertObject({
        type: "warning",
        payload: {
          heading: "Limit reached!",
          description: "Cannot minimize more than 10 LGVs..."
        }
      });
      return;
    }

    if (!isLgvAlreadyMinimized) {
      currentLgvList.push(lgvData);

      setMinimizedWebObjectsList((prev) => ({
        ...prev,
        [feature]: {
          ...prev[feature],
          lgv: currentLgvList
        }
      }));
      setMinimizeInitiated(true);
    }

    // Always close modal
    setTimeout(() => {
      closeModalHandler();
    }, 450);
  };

  useEffect(() => {
    if (lgvData) {
      document.body.classList.add("prevent-scroll");
    }
  }, []);

  //Follow LGV Feature
  const followLgvHandler = () => {
    let existingFollowingLgvList = [...followingLgvList[feature]];

    const indexOfLgvToRemove = existingFollowingLgvList.findIndex(
      ({ vehicleNumber }) => vehicleNumber === lgvData.vehicleNumber
    );

    if (indexOfLgvToRemove !== -1) {
      existingFollowingLgvList.splice(indexOfLgvToRemove, 1);

      dispatch(
        setFollowingLgvList({
          feature,
          list: existingFollowingLgvList
        })
      );
      setIsLgvBeingFollowed(false);
    } else {
      if (existingFollowingLgvList.length < 5) {
        existingFollowingLgvList.push(lgvData);

        dispatch(
          setFollowingLgvList({
            feature,
            list: existingFollowingLgvList
          })
        );
        setIsLgvBeingFollowed(true);
      } else {
        setAlertObject({
          type: "warning",
          payload: {
            heading: "Limit reached!",
            description: "Cannot follow more than 5 LGVs..."
          }
        });
      }
    }
  };

  const RenderLgvFollowButton = () => {
    if (isLgvBeingFollowed) {
      return (
        <div
          onClick={() => followLgvHandler()}
          className={`lgv-follow-button following`}
        >
          <img src={followingIcon} alt="following_icon" />
          <span className="following-text">Following</span>
        </div>
      );
    } else {
      return (
        <div
          onClick={() => followLgvHandler()}
          className={`lgv-follow-button un-following`}
        >
          <img src={followIcon} alt="follow_icon" />
          <span className="un-following-text">Follow</span>
        </div>
      );
    }
  };

  //Modal Animations
  const renderModalAnimation = () => {
    if (minimizeInitiated) {
      return "modal-animation";
    } else {
      return "";
    }
  };

  const isForkClosed = lgvData.forkStatus === "CLOSED";
  const isForkStatusExists = lgvData.forkStatus ? true : false;
  //LGV Alarm and Sensor callbacks
  const lgvAlarmCallback = () => {
    setSelectedLgvGraphicMode("alarm");
    if (isForkStatusExists) {
      if (isForkClosed) {
        setLgvGraphicImage(lgvGraphicsAlarmCloseFork);
      } else {
        setLgvGraphicImage(lgvGraphicsAlarmOpenFork);
      }
    }
  };

  const lgvSensorCallback = () => {
    setSelectedLgvGraphicMode("sensor");
    if (isForkStatusExists) {
      if (isForkClosed) {
        setLgvGraphicImage(lgvGraphicsSensorsCloseFork);
      } else {
        setLgvGraphicImage(lgvGraphicsSensorsOpenFork);
      }
    }
  };

  //LGV Fork open and close
  useEffect(() => {
    if (selectedLgvGraphicMode === "alarm") {
      lgvAlarmCallback();
    }
  }, [lgvData]);

  // Renders SVG and its annotations based on selected mode.
  const renderLgvAlarmStatusIcons = useMemo(() => {
    const RenderAlarmAnnotation = ({ alarm }) => {
      return (
        <div className={`alarm-label ${alarm.className}`} key={alarm.label}>
          <img
            src={
              lgvData.alarmType !== null &&
              lgvData.alarmType.includes(alarm.label)
                ? lgvBadLabelImage
                : lgvGoodLabelImage
            }
            alt="alarm_icon"
          />
          <span>{alarm.label}</span>
        </div>
      );
    };

    const RenderSensorAnnotation = ({ sensor }) => {
      return (
        <div className={`sensor-label ${sensor.className}`} key={sensor.label}>
          <img
            src={
              !(lgvData[sensor.key] ?? false)
                ? lgvGoodLabelImage
                : lgvBadLabelImage
            }
            alt="sensor_icon"
          />
        </div>
      );
    };

    if (lgvData) {
      if (selectedLgvGraphicMode === "alarm") {
        return alarmsAnnotationDetails.map((alarm) => (
          <RenderAlarmAnnotation alarm={alarm} />
        ));
      } else {
        return (
          <>
            {sensorsAnnotationDetails.map((sensor) => (
              <RenderSensorAnnotation sensor={sensor} />
            ))}

            {/* NavQuality Annotation & its Pop-up */}
            <div className="sensor-label lgv-nav-sensor">
              <span className="lgv-nav-sensor-text">
                {lgvData.navQuality !== undefined ? lgvData.navQuality : "0"}%
              </span>
              <NavQualityPopUp lgvData={lgvData} />
            </div>
          </>
        );
      }
    }
  }, [lgvData, selectedLgvGraphicMode]);

  useModalClose(MODAL_ID, () => {
    closeModalHandler();
    closeMinimizedLgvModal();
  });

  return (
    <div
      id={MODAL_ID}
      className={`lgv-popup-wrapper ${
        selectedLgvGraphicMode === "alarm" ? "alarm" : "sensor"
      }`}
    >
      <div className={`lgv-popup-container ${renderModalAnimation()}`}>
        <div className="popup-header">
          <div className="modal-title-section">
            <div className="popup-title">LGV Details</div>
            <RenderLgvFollowButton />
          </div>
          <div className="modal-action-buttons">
            <div
              onClick={() => minimizeModalHandler()}
              className="modal-action-button-wrapper"
            >
              <img
                className="modal-action-button-no-height"
                src={minimizeButton}
                alt="minimize_icon"
              />
            </div>
            <div
              onClick={() => {
                closeModalHandler();
                closeMinimizedLgvModal();
              }}
              className="modal-action-button-wrapper"
            >
              <img
                className="modal-action-button"
                src={closeBtn}
                alt="close_icon"
              />
            </div>
          </div>
        </div>
        <div className="popup-container-details-section">
          <div className="lgv-meta-data-section-wrapper">
            {/* left panel sections */}
            <LGVDataSection lgvData={lgvData} />
            <OnboardPalletDataSection lgvData={lgvData} />
          </div>
          <div className="lgv-graphic-wrapper">
            <div className="lgv-graphic-section">
              <div className="lgv-graphic-switch-section">
                <ToggleSwitch
                  alarmToggle={lgvAlarmCallback}
                  sensorToggle={lgvSensorCallback}
                />
              </div>
              <div className="lgv-graphic-image-section">
                <img src={lgvGraphicImage} alt="graphic_image_icon" />
                {renderLgvAlarmStatusIcons}
              </div>
            </div>
            <span className="seperator" />
            <div className="lgv-graphic-meta-data-section sensor">
              <div className="lgv-graphic-meta-data">
                <RenderLgvGraphicModeMetaData
                  lgvData={lgvData}
                  selectedLgvGraphicMode={selectedLgvGraphicMode}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LgvPopup;
